export var RcClasses = function (classes, prefix) {
    return classes.reduce(function (prev, curr) {
        prev[curr] = prefix + "-" + curr;
        return prev;
    }, {});
};
